var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v("FTP Account Information")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c("strong", [_vm._v("Connection Settings")]),
            _c(
              "v-list",
              [
                _c(
                  "v-list-item",
                  [
                    _c(
                      "v-list-item-content",
                      [
                        _c("v-list-item-subtitle", [_vm._v("FTP Username")]),
                        _c("v-list-item-title", [
                          _vm._v(" " + _vm._s(_vm.account.user) + " ")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("v-divider", {
                  staticClass: "my-0"
                }),
                _c(
                  "v-list-item",
                  [
                    _c(
                      "v-list-item-content",
                      [
                        _c("v-list-item-subtitle", [_vm._v("FTP server")]),
                        _c("v-list-item-title", [
                          _vm._v(" ftp." + _vm._s(_vm.hosting.domain) + " ")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("v-divider", {
                  staticClass: "my-0"
                }),
                _c(
                  "v-list-item",
                  [
                    _c(
                      "v-list-item-content",
                      [
                        _c("v-list-item-subtitle", [
                          _vm._v("FTP & explicit FTPS port")
                        ]),
                        _c("v-list-item-title", [
                          _vm._v(" " + _vm._s(_vm.ftpPort) + " ")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("v-divider", {
                  staticClass: "my-0"
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Close")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }